import { Row, Card, Table } from "antd";
import { useCallback, useMemo } from "react";
import { useLoadData } from "./hooks/loadData";
import { useGetTableColumns } from "./hooks/getTableColumns";
import { useOpenSidebar } from "./hooks/openSidebar";
import { createPortal } from "react-dom";
import { Header } from "./Header";

type PortalAccessProps = {
  customerId: string | null | undefined;
};

export const PortalAccess = ({ customerId }: PortalAccessProps) => {
  const { data, count: total, isLoading, loadData } = useLoadData(customerId);

  const reloadData = useCallback(() => loadData(), [loadData]);

  const { columns } = useGetTableColumns(reloadData);

  const isNextPrimary = useMemo(() => total === 0, [total]);

  const { sideBar, isOpen, setOpen } = useOpenSidebar(
    customerId,
    isNextPrimary,
    reloadData
  );

  const onAddClicked = useCallback(() => setOpen(true), [setOpen]);

  return (
    <Row className="d-block py-6 px-8 h-100 card-table">
      <Card className="w-100 h-100">
        <Header onAddClicked={onAddClicked} />
        <Row className="w-100 d-block card-table__body with-tooltip">
          <Table
            dataSource={data}
            columns={columns}
            loading={isLoading}
            pagination={false}
            rowKey="id"
            className="w-100 h-100 small-table"
          />
        </Row>
      </Card>
      {isOpen && createPortal(sideBar, document.body)}
    </Row>
  );
};
